module.exports = __webpack_public_path__ + "img/vertical_4_1_7005.f33a078f.png";